import { render, staticRenderFns } from "./ProducerModal.vue?vue&type=template&id=e6b964de&scoped=true"
import script from "./ProducerModal.vue?vue&type=script&lang=js"
export * from "./ProducerModal.vue?vue&type=script&lang=js"
import style0 from "./ProducerModal.vue?vue&type=style&index=0&id=e6b964de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b964de",
  null
  
)

export default component.exports